import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { ApiService } from 'projects/admin/src/app/services/api.service'
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core'
import { EmployeeModel } from 'projects/core/src/lib/models/employee.model'
import { MessageService } from 'primeng/api';
import { TranslocoService } from '@ngneat/transloco';
import { Table } from 'primeng/table';
import { Dialog } from 'primeng/dialog';
import { FormHelper } from '../form-helper';

@Component({
  selector: 'app-employee-search',
  templateUrl: './employee-search.component.html',
  styleUrls: ['./employee-search.component.scss']
})
export class EmployeeSearchComponent implements OnInit {

  private dataTable: Table;

  @Output() select = new EventEmitter<EmployeeModel>();
  @ViewChild('table') set table(table: Table) {
    if (table) {
      this.dataTable = table;
    }
  }
  @ViewChild('dialog') dialog: Dialog;

  public searchOpened = false;
  public searchResult = false;
  public loading = false;
  public employees: Array<EmployeeModel> = [];
  public messages: Array<any> = [];
  public markerText = '';

  public maxResultLength = 100;
  public minSearchLength = 3;

  public form: UntypedFormGroup = this.fb.group({
    keywords: new UntypedFormControl('', [Validators.required]),
  });

  constructor(
    private api: ApiService,
    private fb: UntypedFormBuilder,
    private messageService: MessageService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
  }

  public onSubmit(): void {
    if (this.form.get('keywords').value.length < this.minSearchLength) {
      this.form.get('keywords').setValidators([Validators.required, Validators.minLength(3)]);
      this.form.get('keywords').updateValueAndValidity();
    }
    if (this.form.valid === true) {
      this.messageService.clear();
      this.loading = true;
      this.api.searchEmployees(this.form.value).subscribe({
        next: (result: any) => {
          this.searchResult = true;
          this.markerText = this.form.get('keywords').value;
          this.employees = result.data;
          if (this.employees.length >= this.maxResultLength) {
            this.messageService.add({
              key: 'employees',
              severity: 'info',
              summary: this.transloco.translate('common.info'),
              detail: this.transloco.translate('partials.employee_search.too_much_results')
            });
          }
          this.form.get('keywords').setValidators([Validators.required]);
          this.form.get('keywords').updateValueAndValidity();
          setTimeout(() => {
            if (this.dataTable) {
              this.dataTable.reset();
            }
          }, 100);
        },
        error: (error: any) => {}
      }).add(() => {
        this.loading = false;
      });
    } else {
      FormHelper.markFormAsDirty(this.form);
    }
  }

  public open(): void {
    this.searchOpened = true;
  }

  public close(): void {
    this.resetForm();
    this.searchOpened = false;
  }

  public onSelect(employee: EmployeeModel): void {
    this.select.emit(employee);
    this.close();
  }

  private resetForm(): void {
    this.form.get('keywords').setValue('');
    this.form.get('keywords').markAsUntouched();
    this.form.get('keywords').markAsPristine();
    this.messageService.clear();
    this.searchResult = false;
    this.employees = [];
  }

}
